<template>
  <NuxtLink :to="localePath(`/blog${post.path}`)" class="blog-post-item">
    <!-- Cover image -->
    <BaseImageExternal class="blog-cover-image" :src="props.post.coverImage" />

    <!-- Category-buttons -->
    <div class="category-buttons mb-0-5">
      <BaseButton
        v-for="category in post.categories"
        :key="category.id"
        class="blog-button button-outline-white button-extra-small hover-dark"
        @click.prevent="
          router.push(localePath({ query: { c: category.slug } }))
        "
      >
        {{ category.name }}
      </BaseButton>
    </div>

    <!-- Blog titlte -->
    <BaseText class="blog-title mb-1">{{ post.title }}</BaseText>

    <!-- Read more button -->
    <BaseButton
      class="blog-button button-outline-white button-small hover-dark"
    >
      {{ $t("blog.read-more") }}
    </BaseButton>
  </NuxtLink>
</template>

<script setup lang="ts">
import { type WebsitePostOverviewFragment } from "~/graphql/generated";

const props = defineProps<{
  post: WebsitePostOverviewFragment;
}>();

const localePath = useLocalePath();
const router = useRouter();
</script>

<style lang="scss" scoped>
.blog-post-item {
  padding: 1.5rem;
  height: 325px;
  color: $light-100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  background-color: rgba(0, 0, 0, 0.5);
  transition: background-color $easing;

  &:hover {
    background-color: rgba(255, 98, 2, 0.5);

    :deep(.blog-button) {
      background-color: var(--primary);
      border-color: var(--primary);
    }
  }

  .blog-title {
    text-align: center;
  }

  .blog-cover-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: -1;
  }

  .category-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
  }
}
</style>
